import type { ReactNode } from 'react'
import { GraduateProvider } from 'providers/GraduateProvider'

type ServerProvidersProps = {
  children: ReactNode
  featureToggleObject: Record<string, string>
  featurePathOverrides?: Record<string, string> | null
  graduate?: Record<string, unknown> | null
  largestDebtAmount?: number
  fastestCompletion?: number
}

/**
 * Consolidated RSC wrapper: keeps only providers that actually require React Context.
 *
 * Feature flags are read via `getFeatureFlag()` (initialized in `PageProviderClient`)
 * so we avoid wrapping the entire tree for a single mutation use-case.
 */
export function ServerProviders({
  children,
  graduate = null,
  largestDebtAmount,
  fastestCompletion,
}: ServerProvidersProps) {
  return (
    <GraduateProvider
      initialState={graduate as unknown as null}
      initialHighlights={{ largestDebtAmount, fastestCompletion }}
    >
      {children}
    </GraduateProvider>
  )
}
